export const tierDropdown = [
  { key: 1, text: "Tier 1", value: 1 },
  { key: 2, text: "Tier 2", value: 2 },
  { key: 3, text: "Tier 3", value: 3 },
  { key: 4, text: "Tier 4", value: 4 },
];
